import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/submit', params, options);

export const monthChargeRuleList = (params, options) =>
  request.get(
    '/api/v4ward/car/monthChangeRule/monthChargeRuleList',
    Object.assign({}, options, { params })
  );
export const disable = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/disable', qs.stringify(params), options);
